const initialState = {
    message: '',
    selectedTemplate: null,
    from_phone: 4242094923,
    file: null
};

export default initialState;
